import { t } from '@vitesse/base-ui/i18n';
import type { PillTab } from '@vitesse/base-ui/components/templates';

/** What the gateway page holds, counted. One number per entity kind — the tab
 *  bar renders these and nothing else. */
export interface GatewayCounts {
  controllers: number;
  models: number;
  integrations: number;
  cameras: number;
  dashboards: number;
}

/*
 * The gateway page's tab bar, as a pure function of what the page holds.
 *
 * Extracted from the component because of a defect that lived comfortably
 * inside it: the dashboards tab shipped with `count: 0`, hardcoded, while its
 * four siblings counted their arrays — a gateway with sixteen boards showed a
 * tab reading zero, and nothing could test it without rendering the component,
 * which this repo's test infrastructure deliberately does not do.
 *
 * As a function of a counts object, the property is checkable directly: every
 * tab's count IS its entity's count, so a literal smuggled in here fails a test
 * instead of shipping a confident wrong number. A wrong number is worse than a
 * missing one — nobody investigates a zero that renders cleanly.
 */
export function gatewayTabs(c: GatewayCounts): PillTab[] {
  return [
    { id: 'all', label: t('nav.all') },
    { id: 'controllers', label: t('nav.controllers'), icon: 'cpu', count: c.controllers },
    { id: 'models', label: t('nav.models'), icon: 'git-compare-arrows', count: c.models },
    { id: 'integrations', label: t('nav.integrations'), icon: 'database-arrow-up', count: c.integrations },
    { id: 'cameras', label: t('nav.cameras'), icon: 'camera', count: c.cameras },
    { id: 'dashboards', label: t('nav.dashboards'), icon: 'bar-chart-3', count: c.dashboards },
  ];
}
